exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Content-module__wrapper___2owoF{display:grid;gap:1rem}.Content-module__wrapper___2owoF h2{margin-bottom:.25rem}.Content-module__wrapper___2owoF h3{margin-bottom:.5rem}.Content-module__wrapper___2owoF .Content-module__grid___14AuD,.Content-module__wrapper___2owoF .Content-module__items___1mHwF{display:grid;gap:1rem}.Content-module__wrapper___2owoF .Content-module__items___1mHwF{grid-template-columns:repeat(auto-fill,minmax(150px,1fr))}.Content-module__wrapper___2owoF .Content-module__projects___1m1qg{display:grid;grid-template-columns:1fr;gap:1.5rem}@media screen and (min-width:525px){.Content-module__wrapper___2owoF .Content-module__projects___1m1qg{grid-template-columns:repeat(auto-fill,minmax(400px,1fr))}}.Content-module__wrapper___2owoF .Content-module__sparks___3ogKL{display:grid;gap:.25rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Content-module__wrapper___2owoF",
	"grid": "Content-module__grid___14AuD",
	"items": "Content-module__items___1mHwF",
	"projects": "Content-module__projects___1m1qg",
	"sparks": "Content-module__sparks___3ogKL"
};